import type { Dayjs } from "dayjs";

enum ERewardType {
  LOL_ACCOUNT_REWARD = "lol_account_reward",
  VALORANT_ACCOUNT_REWARD = "valorant_account_reward",
  COUPON_REWARD = "coupon_reward",
}

interface IBaseClaim {
  type: ERewardType;
  i18nKey: string;
  date: Dayjs;
}

export interface IAccountClaim extends IBaseClaim {
  type: ERewardType.LOL_ACCOUNT_REWARD | ERewardType.VALORANT_ACCOUNT_REWARD;
  username: string;
  password: string;
  code?: never;
}

export interface ICouponClaim extends IBaseClaim {
  type: ERewardType.COUPON_REWARD;
  code: string;
  username?: never;
  password?: never;
}

export type IClaim = IAccountClaim | ICouponClaim;

export const isAccountClaim = (claim: IClaim): claim is IAccountClaim => {
  return (claim as IAccountClaim).username !== undefined;
};

export const isCouponClaim = (claim: IClaim): claim is ICouponClaim => {
  return (claim as IAccountClaim).code !== undefined;
};
